// import "@/scripts/global/utils/LocalizationForm"
import "@/scripts/sections/FooterMenu.js"

import Alpine from "alpinejs"
import focus from "@alpinejs/focus"
import collapse from '@alpinejs/collapse'


import sticky_header from '@/scripts/components/sticky-header'
// import product_gallery from "@/scripts/templates/product/product_gallery"
// import scroll_to_top_btn from "@/scripts/components/scroll-to-top-btn"
// import product_card from "@/scripts/templates/product/product-card"
import swiper from "@/scripts/components/swiper"
// import klaviyo_newsletter from "@/scripts/sections/klaviyo-newsletter"
// import faq from "@/scripts/sections/faq"
import simple_video from "@/scripts/sections/simple_video"
// import comparison_section from "@/scripts/sections/comparison_section"
import accordion from "@/scripts/components/accordion"
// import contact_form from "@/scripts/sections/contact_form"
// import customer from "@/scripts/templates/customer/customer"
// import backInStosk from "@/scripts/templates/product/backInStosk"
// import infoBanner from "@/scripts/sections/info-banner";
import splideSlider from "@/scripts/components/splide-slider";
import textColorAnimation from "@/scripts/sections/text-color-animation"

// Moved back to the global scope
// import searchSuggestions from "@/scripts/components/search-suggestions";
import imageBanner from "@/scripts/sections/image_banner";
import pageHeader from "@/scripts/sections/page_header";
// import navigation from "@/scripts/sections/navigation";
// import collection from "@/scripts/collection/collection";
// import product from "@/scripts/templates/product/product";
// import multimediaTestimonials from "@/scripts/sections/multimedia-testimonials"
// import tabbedProductCards from "@/scripts/sections/tabbed-product-cards"


Alpine.plugin(focus)
Alpine.plugin(collapse)
window.Alpine = Alpine

document.addEventListener("alpine:init", () => {
  Alpine.data("swiper", swiper)
  // Alpine.data("product_gallery", product_gallery)
  // Alpine.data("scroll_to_top_btn", scroll_to_top_btn)
  /*Alpine.data("main_product", product)*/
  // Alpine.store("product_card", product_card())
  // Alpine.data("klaviyo_newsletter", klaviyo_newsletter)
  // Alpine.data("faq", faq)
  Alpine.data("simple_video", simple_video)
  // Alpine.data("comparison_section", comparison_section)
  Alpine.data("accordion", accordion)
  // Alpine.data("contact_form", contact_form)
  // Alpine.data("customer", customer)
  // Alpine.data("backInStosk", backInStosk)
  // Alpine.data("infoBanner", infoBanner)
  Alpine.data("splide", splideSlider)
  Alpine.data("textColorAnimation", textColorAnimation)

  // Moved back to the global scope
  // Alpine.data("searchSuggestions", searchSuggestions);
  Alpine.data("imageBanner", imageBanner);
  // Alpine.data("navigation", navigation);
  Alpine.data("pageHeader", pageHeader);
  
  // Alpine.data("collection", collection);
  // Alpine.data("main_product", product)
  // Alpine.data("multimediaTestimonials", multimediaTestimonials)
  // Alpine.data("tabbedProductCards", tabbedProductCards)


})

Alpine.start()

